import { render, staticRenderFns } from "./peopleCourseWeekRegistration.vue?vue&type=template&id=138d6642&scoped=true&"
import script from "./peopleCourseWeekRegistration.vue?vue&type=script&lang=js&"
export * from "./peopleCourseWeekRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d6642",
  null
  
)

export default component.exports